module.exports = __webpack_public_path__ + "static/mental_health_secret_banner-5bf344900d43df3affb6e03fe36b599c.png";